import { customElement } from 'lit/decorators';
import { css, html, LitElement } from 'lit';
import { center, padding, row } from '../styles';
import { unsafeHTML } from 'lit-html/directives/unsafe-html';

@customElement('pdq-tutorial-using-model-from-code')
class PDQTutorialConfigOverlay extends LitElement {
  static styles = [
    row,
    center,
    padding,
  ];

  render() {
    const evalScript = `
let nextId = 0;
function randomInt(min, max) {
    return Math.floor(Math.random() * (max - min + 1) + min);
}
function createRandomPerson() {  
  const id = nextId++;
  const firstNames = [
    "Alice", "Bob", "Carol", "David", "Eve", "Frank", "Grace", "Helen", 
    "Ian", "Jane", "Kyle", "Laura", "Mike", "Nora", "Oscar", "Paula", 
    "Quincy", "Rachel", "Steve", "Tina", "Ulysses", "Violet", "Walter", 
    "Xena", "Yvonne", "Zach", "Amber", "Brad", "Claire", "Dexter"
  ];
  const lastNames = [
    "Smith", "Johnson", "Williams", "Brown", "Jones", "Miller", "Davis", 
    "Garcia", "Rodriguez", "Wilson", "Martinez", "Anderson", "Taylor", 
    "Thomas", "Hernandez", "Moore", "Martin", "Jackson", "Thompson", 
    "White", "Lopez", "Lee", "Gonzalez", "Harris", "Clark", "Lewis", 
    "Robinson", "Walker", "Perez", "Hall"
  ];

  const getRandomElement = (array) => array[Math.floor(Math.random() * array.length)];
  
  const firstName = getRandomElement(firstNames);
  const lastName = getRandomElement(lastNames);
  const email = firstName.toLowerCase() + '.' + lastName.toLowerCase() + '@example.com';
  
  return {id,firstName,lastName,email};
}

pdq.dataBroker
  .getObservableDataSource('randomPeople')
  .then(i => i.subscribe(j => {
  console.log('*************')
  console.log(j)
  console.log('************')
}));
  
const people = Array.from({length: 6}, createRandomPerson);
console.log(people)

console.log('------------------')
pdq.dataBroker.setDataSource('randomPeople', people);
console.log('------------------')

setInterval(() => {
  console.log('adding random person')
  const rp = createRandomPerson();
  rp.id = randomInt(0, 5);
  pdq.dataBroker.setDataSource('randomPeople', [rp]);
}, 10000);
`;
    const code = `
<script>${evalScript}</script>
<pdq-table index="id" id="people-table" source="randomPeople"></pdq-table>
<pdq-perspective-viewer height="220px" table="people-table"></pdq-perspective-viewer>
`;

    eval(evalScript);
    return html`
      <cds-tile class="col">
        <h2>Using the model from code...</h2>
        <pdq-code-html code="${code}"></pdq-code-html>
        ${unsafeHTML(code)}
      </cds-tile>
    `;
  }
}